__turbopack_context__.v({
  "fourthScreenContainer": "SixthScreenInfra-module-scss-module__UsAiJG__fourthScreenContainer",
  "fourthScreenDescription": "SixthScreenInfra-module-scss-module__UsAiJG__fourthScreenDescription",
  "fourthScreenImgOne": "SixthScreenInfra-module-scss-module__UsAiJG__fourthScreenImgOne",
  "fourthScreenImgTwo": "SixthScreenInfra-module-scss-module__UsAiJG__fourthScreenImgTwo",
  "fourthScreenSvg_one": "SixthScreenInfra-module-scss-module__UsAiJG__fourthScreenSvg_one",
  "fourthScreenSvg_two": "SixthScreenInfra-module-scss-module__UsAiJG__fourthScreenSvg_two",
  "fourthScreenTextBox": "SixthScreenInfra-module-scss-module__UsAiJG__fourthScreenTextBox",
  "fourthScreenTitle": "SixthScreenInfra-module-scss-module__UsAiJG__fourthScreenTitle",
  "fourthScreenWrapper": "SixthScreenInfra-module-scss-module__UsAiJG__fourthScreenWrapper",
});
